import { CommonTranslationKey } from '../../utils/localisation'

export type SearchlightPageParams = {
  page: number
  pageSize: number
}

export enum EntityType {
  bookings = 'bookings',
  shipments = 'shipments',
  customerReference = 'customerReference',
  poNumbers = 'poNumbers',
  customers = 'customers',
  activities = 'activities',
  invoices = 'invoices',
  financeBook = 'financeBook',
  legalEntity = 'legalEntity',
  houseBillOfLading = 'houseBillOfLading',
  masterBillOfLading = 'masterBillOfLading',
  masterAirwayBillOfLading = 'masterAirwayBillOfLading',
  containerNumber = 'containerNumber',
}

export type SearchResponse = {
  entityID: string
  entityType: EntityType
  searchContent: string
  v2Flow?: boolean
  customerID?: string

  metadata: {
    shipmentID: string
    bookingID: string
    accountID: string
    accountName: string
  }
}

export type PaginatedSearchlightResponse = {
  items: SearchResponse[]
  totalItems: number
  totalPages: number
}

export type SearchlightGroup = {
  title: CommonTranslationKey
  results: SearchResponse[]
}
